import { render, staticRenderFns } from "./WebhookCardPage.vue?vue&type=template&id=a2b1ed2e&"
import script from "./WebhookCardPage.vue?vue&type=script&lang=js&"
export * from "./WebhookCardPage.vue?vue&type=script&lang=js&"
import style0 from "./WebhookCardPage.vue?vue&type=style&index=0&id=a2b1ed2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports